import { AssetCheckException } from "~/pages/findings/Exceptions/types";
import { MONDOO_ASSET_API_URL } from "../../constants";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";

export const ASSET_ID_PARAM = "assetId";

export const getAssetMrn = (
  spaceId: string,
  assetId: string | null | undefined,
): string => {
  if (!assetId) return "";

  return `${MONDOO_ASSET_API_URL}/spaces/${spaceId}/assets/${assetId}`;
};

export const getPolicyPropertiesTabUrl = ({
  policyId,
  spaceId,
}: {
  policyId?: string;
  spaceId?: string;
}) => {
  if (!policyId || !spaceId) return "";

  return `/space/findings/policies/${policyId}/properties?spaceId=${spaceId}`;
};

export const getToSpaceSettings = (spaceId: string): string => {
  return `/space/settings?spaceId=${spaceId}`;
};

export const getCriticalExposuresUrl = (
  scope: SpaceOrWorkspaceScope | undefined,
) => (scope ? `/space/dashboard/critical-exposures?${scope.params}` : "");

export const getExceptionDetailUrl = ({
  spaceId,
  exceptionId,
}: {
  spaceId: string;
  exceptionId: string;
}) => {
  return `/space/findings/exceptions?spaceId=${spaceId}&exceptionId=${exceptionId}`;
};

export const getCveDetailUrl = ({
  scope,
  cveId,
  spaceId,
  assetId,
}: {
  scope: "asset" | "space";
  cveId: string;
  spaceId: string;
  assetId?: string;
}) => {
  if (scope === "asset") {
    return `/space/inventory/${assetId}/vulnerabilities/${cveId}?scopeId=${spaceId}`;
  }
  return `/space/vulns/cve/${cveId}?spaceId=${spaceId}`;
};

export const getCheckDetailUrl = ({
  scope,
  checkMrn,
  spaceId,
  assetId,
}: {
  scope: "asset" | "space";
  checkMrn: string;
  spaceId: string;
  assetId?: string;
}) => {
  if (scope === "asset") {
    return `/space/inventory/${assetId}/check?checkMrn=${encodeURIComponent(
      checkMrn,
    )}&spaceId=${spaceId}`;
  }

  return `/space/findings/check?spaceId=${spaceId}&findingMrn=${checkMrn}`;
};

export const getSpaceAdvisoryDetailUrl = ({
  advisoryId,
  spaceId,
}: {
  advisoryId: string;
  spaceId: string;
}) => {
  return `/space/vulns/advisory/${advisoryId}?spaceId=${spaceId}`;
};

export const getAssetDetailUrl = ({
  assetId,
  spaceId,
}: {
  assetId: string;
  spaceId: string;
}) => {
  return `/space/inventory/${assetId}/exceptions?spaceId=${spaceId}`;
};

export const getInitiativeDetailUrl = ({
  initiativeMrn,
  scopeParams,
}: {
  initiativeMrn: string;
  scopeParams: URLSearchParams | null | undefined;
}) => {
  const queryParams = new URLSearchParams(scopeParams || new URLSearchParams());
  return `/space/dashboard/initiatives/${encodeURIComponent(initiativeMrn)}?${queryParams.toString()}`;
};
